import MainScreen from "./VideoChatContents/components/MainScreen/MainScreen.component"//greetings
import MainScreen2 from "./LiveVideoCallContent/components/MainScreen/MainScreen.component"; //live chat
import firepadRef, { db } from "./VideoChatContents/server/firebase";
import "./VideoCall.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

import {
  setMainStream,
  addParticipant,
  setUser,
  removeParticipant,
  updateParticipant,
} from "./VideoChatContents/store/actioncreator";
import { connect } from "react-redux";

function LiveVideoChat(props) {

  const live_chat_slug = props.match.params.slug;
  const [event, setEvent] = useState([]);
  const [registeredLiveChat, setRegisteredLiveChat] = useState([]);
  const [dataLoad, setdataLoad] = useState(false)
  const[canvaStatus, setCanvaStatus] = useState(true);

  const urlparams = new URLSearchParams(window.location.search);
  const roomId = urlparams.get("id");

  const getUserStream = async () => {
    const localStream = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: true,
    });

    return localStream;
  };

  //const [userName, setUserName] = useState('');

  let userName = localStorage.getItem('auth_type');


  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {

    if (roomId) {
      setCanvaStatus(false)
     
    }
    let isMounted = true;

    axios.get(`/api/star/registeredUserList/${live_chat_slug}`).then(res => {
      setdataLoad(true)
      if (isMounted) {
        if (res.data.status === 200) {
          setRegisteredLiveChat(res.data.registeredLiveChats);
          setEvent(res.data.event)
        }
      }
    });

    const stream = await getUserStream();

    stream.getVideoTracks()[0].enabled = false;
    props.setMainStream(stream);

    connectedRef.on("value", (snap) => {
      if (snap.val()) {
        const defaultPreference = {
          audio: true,
          video: false,
          screen: false,
        };
        const userStatusRef = participantRef.push({
          userName,
          preferences: defaultPreference,
        });
        props.setUser({
          [userStatusRef.key]: { name: userName, ...defaultPreference },
        });
        userStatusRef.onDisconnect().remove();
      }
    });
  }, []);

  const connectedRef = db.database().ref(".info/connected");
  const participantRef = firepadRef.child("participants");

  const isUserSet = !!props.user;
  const isStreamSet = !!props.stream;

  useEffect(() => {
    if (isStreamSet && isUserSet) {
      participantRef.on("child_added", (snap) => {
        const preferenceUpdateEvent = participantRef
          .child(snap.key)
          .child("preferences");
        preferenceUpdateEvent.on("child_changed", (preferenceSnap) => {
          props.updateParticipant({
            [snap.key]: {
              [preferenceSnap.key]: preferenceSnap.val(),
            },
          });
        });
        const { userName: name, preferences = {} } = snap.val();
        props.addParticipant({
          [snap.key]: {
            name,
            ...preferences,
          },
        });
      });
      participantRef.on("child_removed", (snap) => {
        props.removeParticipant(snap.key);
      });
    }
  }, [isStreamSet, isUserSet]);

  return (
    <div className="App">
      <MainScreen2 data={registeredLiveChat} event={event} loading={dataLoad} canvaStatus={canvaStatus}/>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    stream: state.mainStream,
    user: state.currentUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setMainStream: (stream) => dispatch(setMainStream(stream)),
    addParticipant: (user) => dispatch(addParticipant(user)),
    setUser: (user) => dispatch(setUser(user)),
    removeParticipant: (userId) => dispatch(removeParticipant(userId)),
    updateParticipant: (user) => dispatch(updateParticipant(user)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LiveVideoChat);
